module.exports = __webpack_public_path__ + "static/img/list-wispPediatricNasalMask.f2dca0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-wispPediatricNasalMask.png
// module id = Kzl0
// module chunks = 1